import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 100 125"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M91 32.1H8c-2.5 0-4.6-2.1-4.6-4.6s2.1-4.6 4.6-4.6h83c2.5 0 4.6 2.1 4.6 4.6s-2.1 4.6-4.6 4.6M21.9 45.9h55.3c2.5 0 4.6 2.1 4.6 4.6s-2.1 4.6-4.6 4.6H21.9c-2.5 0-4.6-2.1-4.6-4.6-.1-2.5 2-4.6 4.6-4.6m13.8 23h27.6c2.5 0 4.6 2.1 4.6 4.6s-2.1 4.6-4.6 4.6H35.7c-2.5 0-4.6-2.1-4.6-4.6s2-4.6 4.6-4.6",
      style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
    }, null, -1)
  ])))
}
export default { render: render }